export const LOGIN = `/admin/open/login`
export const USER_INFO = `/admin/api/user/info`
export const UPLOAD = `/admin/api/tool/upload`
export const TEMPLATE_LIST = `/admin/api/template/list`
export const TEMPLATE_UPDATE = `/admin/api/template/update`
export const KNOWLEDGE_LINK = `/admin/api/template/knowledge/link`
export const KNOWLEDGE_DELETE = `/admin/api/template/knowledge/delete`

export const CONFIG_HELLO_LIST = `/admin/api/hello_config/list`
export const CONFIG_HELLO_UPDATE = `/admin/api/hello_config/update`

export const CHANNEL_LIST = `/admin/api/channel/list`
export const CHANNEL_CREATE = `/admin/api/channel/create`
export const CHANNEL_DELETE = `/admin/api/channel/delete`



export const ARTICLE_LIST = `/admin/api/article/list`
export const ARTICLE_DETAIL = `/admin/api/article/detail`
export const ARTICLE_UPDATE = `/admin/api/article/update`
export const ARTICLE_QUIZ = `/admin/api/article/quiz`
export const ARTICLE_VOCABULARY = `/admin/api/article/vocabulary`
export const USER_LIST = `/admin/api/user/list`
export const VIP_OPEN = `/admin/api/vip/open`
export const VOICE_WHITE = `/admin/api/voice/white`


export const WRITING_TASK_LIST = `/admin/api/writing/task/list`
export const WRITING_TASK_DELETE = `/admin/api/writing/task/delete`
export const WRITING_TASK_UPDATE = `/admin/api/writing/task/update`
export const WRITING_TASK_CREATE = `/admin/api/writing/task/create`
export const WRITING_TASK_DETAIL = `/admin/api/writing/task/detail`



export const LLM_CHANNEL_LIST = `/admin/api/llm/channel/list`
export const LLM_CHANNEL_UPDATE = `/admin/api/llm/channel/update`
export const LLM_CHANNEL_CREATE = `/admin/api/llm/channel/create`
export const LLM_CHANNEL_DELETE = `/admin/api/llm/channel/delete`
export const LLM_CHANNEL_PING = `/admin/api/llm/channel/ping`

export const LLM_WORKFLOW_LIST = `/admin/api/llm/workflow/list`
export const LLM_WORKFLOW_RUN = `/admin/api/llm/workflow/run`
export const LLM_WORKFLOW_RUN_RESULT = `/admin/api/llm/workflow/run/result`
export const LLM_WORKFLOW_UPDATE = `/admin/api/llm/workflow/update`
export const LLM_WORKFLOW_CREATE = `/admin/api/llm/workflow/create`



export const LLM_DISPATCH_LIST = `/admin/api/llm/dispatch/list`
export const LLM_DISPATCH_UPDATE = `/admin/api/llm/dispatch/update`
export const LLM_DISPATCH_CREATE = `/admin/api/llm/dispatch/create`


export const TRAIN = `/admin/api/template/train`

